import { render } from "./BreadCrumbDynamic.vue?vue&type=template&id=6e3d6974&scoped=true"
import script from "./BreadCrumbDynamic.vue?vue&type=script&lang=js"
export * from "./BreadCrumbDynamic.vue?vue&type=script&lang=js"

import "./BreadCrumbDynamic.vue?vue&type=style&index=0&id=6e3d6974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3d6974"]])

export default __exports__